import * as React from 'react';

import { Query } from '@apollo/client/react/components';

import { Text } from '@shared/components/bootstrap';
import { ConfigWithSetup } from '@shared/components/inventory_capture';
import { Summary } from '@shared/components/inventory_capture/summary';
import { IInventoryConfig } from '@shared/types/inventory_config';
import { IOrder } from '@shared/types/order';
import { buildOrderInventory } from '@shared/utils/build_order_inventory';

import { client } from '@admin/libraries/apollo';
import { OrderTypeEnum } from '@admin/schema';
import { OrderDetailsDocument } from '@admin/schema';

interface IQueryData extends IInventoryConfig {
  order: IOrder;
}

interface IQueryVariables {
  orderID: string;
}

export const InventorySummary: React.FC<{
  orderID: string;
  /** Hides legacy pickup item lists (replaced by Order Estimates tab). */
  hideItemLists?: boolean;
}> = ({ orderID, hideItemLists }) => (
  <Query<IQueryData, IQueryVariables>
    client={client}
    query={OrderDetailsDocument}
    variables={{ orderID: String(orderID) }}
    fetchPolicy="no-cache"
  >
    {({ data }) => {
      if (!data || !data.order) {
        return null;
      }
      const { order, ...config } = data;

      return (
        <div id="inventory_summary">
          {order.services.map(
            (service, key) =>
              service.type === OrderTypeEnum.Pickup &&
              service.id === orderID && (
                <ConfigWithSetup key={key} {...config} inventory={buildOrderInventory(service, config)}>
                  <Summary hideItemLists={hideItemLists} />
                  <Text tag="p">
                    <strong>Estimated:</strong>{' '}
                    {service.estimatedCuft != null && Number.isFinite(service.estimatedCuft) ? (
                      <>
                        {service.estimatedCuft.toFixed(2)} ft<sup>3</sup>
                      </>
                    ) : (
                      '—'
                    )}
                  </Text>
                </ConfigWithSetup>
              ),
          )}
        </div>
      );
    }}
  </Query>
);
